<template>
  <div
    class="round-image"
    :style="{ backgroundImage: `url('${src}')` }"
    :class="{ empty: !src} "
  />
</template>

<script>
export default {
  name: 'RoundImage',
  props: {
    src: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  .round-image {
    height: 40px;
    width: 40px;
    border-radius: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    &.empty {
      background-color: $dividerColor;
    }
  }
</style>
